/**
 * Created by mac on 4/13/24
 */

HideAnimations = function (f) {
    const sceneComponent = ComponentMap.get(this.node, YatzySceneComponent);

    cleverapps.focusManager.compound(f, [
        function (f) {
            sceneComponent.yatzyField.animateHide(f);
            sceneComponent.dicesView.animateHide();
        },

        function (f) {
            sceneComponent.resultsBar.animateHide();
            sceneComponent.rollButton.animateHide();
            setTimeout(f, 500);
        }
    ]);
};
